import { isCompletedOrFuturePickup } from '../../utils/utils';
import { isNotAssignedPickup, isNotCompletedPickup } from '../filterUtils';
import { DRIVER_GRID_COMMANDS } from '../Drivers/Grid/constants';

export type DriverGridAssignmentCommand =
  (typeof DRIVER_GRID_COMMANDS)[keyof typeof DRIVER_GRID_COMMANDS];

export type AssignmentRulePickup = {
  driverId?: string | null;
  pickupDate?: string | null;
  isCompleted?: boolean;
  isFuture?: boolean;
  isVoided?: boolean;
  isMissed?: boolean;
};

type PickupAssignmentCommandParams = {
  pickup?: AssignmentRulePickup | null;
  command: DriverGridAssignmentCommand;
  terminalOffset?: string;
};

type DriverGridAssignmentDisabledParams = {
  selectedPickups?: AssignmentRulePickup[] | null;
  command: DriverGridAssignmentCommand;
  terminalOffset?: string;
};

export const isPickupEligibleForAssignmentCommand = ({
  pickup,
  command,
  terminalOffset,
}: PickupAssignmentCommandParams): boolean => {
  if (!pickup || isCompletedOrFuturePickup(pickup)) {
    return false;
  }

  if (command === DRIVER_GRID_COMMANDS.ASSIGN) {
    return isNotAssignedPickup({ pickup, terminalOffset });
  }

  if (
    command === DRIVER_GRID_COMMANDS.UNASSIGN ||
    command === DRIVER_GRID_COMMANDS.REASSIGN
  ) {
    return isNotCompletedPickup({ pickup, terminalOffset });
  }

  return false;
};

export const isDriverGridAssignmentDisabled = ({
  selectedPickups,
  command,
  terminalOffset,
}: DriverGridAssignmentDisabledParams): boolean => {
  if (!selectedPickups?.length) {
    return true;
  }

  return !selectedPickups.every((pickup) =>
    isPickupEligibleForAssignmentCommand({ pickup, command, terminalOffset })
  );
};
